import { Controller } from 'react-hook-form';
import { FC } from 'react';

import { AboutFormControlProps } from '../../types';
import { CollapseCheckbox } from '../components/collapseCheckbox';
import { KjelVannbarenVarme, kjelVannbarenVarmeDefaultValue } from '../components/kjelVannbarenVarme';
import { useAboutFormContext } from '../../utils';

export const Gasskjel: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue, trigger } = useAboutFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingGass.kjel.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.gassKjel.label"
          error={!!fieldState.error}
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const newValue = checked ? kjelVannbarenVarmeDefaultValue : undefined;

            setValue('oppvarming.oppvarmingGass.kjel.value', newValue);
            trigger('oppvarmingSelection.oppvarmingGass');
          }}
        >
          <KjelVannbarenVarme name="oppvarming.oppvarmingGass.kjel.value" control={control} />
        </CollapseCheckbox>
      )}
    />
  );
};
